import React, { useState, useEffect, useRef } from 'react';
import { Container, Form, Image, } from 'react-bootstrap';
import FormInput from '../../common/FormInput';
import FormLabel from '../../common/FormLabel';
import { HiOutlineChevronLeft } from '@react-icons/all-files/hi/HiOutlineChevronLeft';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { addCampCaptainErrors } from '../../../constants/error.constants';
import LoadButton from '../../common/LoadButton';
import { ADD_CAPTAIN, MY_SCHOOL_ROUTE } from '../../../constants/routes.constants';
import PartnerHeader from './PartnerHeader';
import { ErrorMessage } from '@hookform/error-message';
import { schoolViewModel } from './school.view.model';
import ChallengeModal from '../../common/ChallengeModal';
import customizeBannerUpload from '../../../assets/images/upload-ic.svg';
import { imageUtils } from '../../../utils/image.utils';
import ImageCropModal from '../../common/image-crop-rotate/ImageCropModal';
import { useAuth } from '../../auth/Auth';
import { checkEmailValidation } from '../../../utils/utils';
import veryfiedIcon from '../../../assets/icon/verify-badge.svg';
import unVeryfiedIcon from '../../../assets/icon/Unverified.svg';
import defaultProfilePic from '../../../assets/profile/default-profile-guardian.svg';
import zIndex from '@mui/material/styles/zIndex';

const CampEditCaptain = () => {
  const history = useHistory();
  const { school } = useAuth();
  const pageRedirect = () => {
    history.goBack();
  }
  const [campCaptainsList, setCampCaptainsList] = useState([]);
  const [campCaptainsOptions, setCampCaptainsOptions] = useState({})
  const [selectedCampCaptain, setSelectedCampCaptain] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [isDisabled, setIsDisable] = useState(false);
  const [imageCropPopup, setImageCropPopup] = useState(false);
  const [imageForCrop, setImageForCrop] = useState(null);
  const profileImage = useRef();
  const { register, watch, handleSubmit, setError, errors, getValues } = useForm({
    mode: 'onBlur',
  });
  const [captainDetails, setCaptainDetails] = useState({
    captainFirstName: '',
    captainLastName: '',
    captainEmail: ''
  })

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 48,
      color: '#321b6d',
      fontWeight: '400',
      zIndex: 9
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  const getCampCaptains = () => {
    const params = {
      limit: 99
    }
    schoolViewModel.getCampCaptainsList(school?.id, params).then((res) => {
      setCampCaptainsList(res)
      setCampCaptainsOptions(res?.map((obj) => {
        return { value: obj?.id, label: <div className='camp_captain_list-wrapper'><img src={obj?.profile?.picture_url ? obj?.profile?.picture_url : defaultProfilePic} className='camp_captain_list-img' /> <p className='camp_captain_list'>{obj?.first_name} {obj?.last_name}<img className='camp_captain_is_veryfied' src={obj?.is_verified ? veryfiedIcon : unVeryfiedIcon} /></p></div> }
      }));
    }).catch((err) => {
      console.log(err)
    })
  }

  useEffect(() => {
    getCampCaptains();
  }, [])

  const onSubmit = handleSubmit(async (formData) => {
    setIsLoading(true);
    const params = getValues();
    let body = {
      first_name: params["captainFirstName"],
      last_name: params["captainLastName"],
      email: params["captainEmail"]
    };

    // Check for email validation errors
    if (!checkEmailValidation(captainDetails?.captainEmail)) {
      setError("captainEmail", {
        type: 'manual',
        message: addCampCaptainErrors.email.invalid,
      });
      setIsLoading(false);
      return; // Exit function if there are errors
    }

    try {
      // Perform form submission if there are no errors
      if (uploadImage) {
        await schoolViewModel.addCampCaptainMedia(selectedCampCaptain.id, uploadImage);
      }
      let res = await schoolViewModel.editCampCaptain(selectedCampCaptain.id, body);
      history.push({ pathname: MY_SCHOOL_ROUTE });
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setError("captainEmail", {
        type: 'manual',
        message: addCampCaptainErrors.email.exist,
      });
    }
  });


  const handleProfileImageSelection = (e) => {
    const files = e.target.files;
    setIsDisable(true);
    if (files.length) {
      setImageForCrop(files[0])
      setImageCropPopup(true)
    }
  };

  const onCropComplete = (croppedImage) => {
    const imagePromise = imageUtils.getImagePromise(croppedImage);
    imagePromise
      .then((image) => {
        setProfilePic(image.preview);
        setUploadImage(image);
        setImageForCrop(null);
        setIsDisable(false);
      });
  }

  const handleDelete = () => {
    try {
      schoolViewModel.deleteCampCaptain(selectedCampCaptain?.id)
      schoolViewModel.deleteCampCaptainMedia(selectedCampCaptain?.id)
    } catch (error) {
      console.log(error)
    }
    setCampCaptainsOptions(campCaptainsOptions.filter((obj) => obj.value !== selectedCampCaptain.id))
    setCampCaptainsList(campCaptainsList.filter((obj) => obj.id !== selectedCampCaptain.id))
    setSelectedCampCaptain(null);
    setShowDeleteConfirm(false);
  }

  const handleCloseDeleteConfirm = () => {
    setShowDeleteConfirm(false);
    setIsDeleteLoading(false);
  };

  const handleCampCaptainSelect = (e) => {
    let index = campCaptainsList.findIndex(item => item.id === e.value)
    setSelectedCampCaptain(campCaptainsList[index])
    setProfilePic(campCaptainsList[index]?.profile?.picture_url)
    setCaptainDetails({
      captainEmail: campCaptainsList[index]?.email,
      captainFirstName: campCaptainsList[index]?.first_name,
      captainLastName: campCaptainsList[index]?.last_name
    })
  }

  const handleDeleteCampCaptain = () => {
    setShowDeleteConfirm(true);
  }

  const handleChange = (e) => {
    let { name, value } = e.target
    setCaptainDetails((prevState) => ({ ...prevState, [name]: value }))
  }

  return (
    <div className='partner-wrapper-main'>
      <PartnerHeader />
      <ImageCropModal
        imageCropPopup={imageCropPopup}
        setImageCropPopup={setImageCropPopup}
        image={imageForCrop}
        setImage={setImageForCrop}
        setPicture={onCropComplete}
        heading='Edit your profile image'
      />
      <ChallengeModal
        handleClose={handleCloseDeleteConfirm}
        handleAction={handleDelete}
        show={showDeleteConfirm}
        type="confirm"
        level="warning"
        button1Label="Delete"
        button2Label="Cancel"
      >
        <div>
          <span>Are you sure you want to delete this captain?</span>
        </div>
      </ChallengeModal>
      <div className='add-more-branches partner_add_challenges'>
        <span className="back-btn" onClick={pageRedirect}><HiOutlineChevronLeft /></span>
        <Container>
          <div>
            <div className='right-btn text-right'>
              <button onClick={() => history.push(ADD_CAPTAIN)} className='common-round-btn edit-button button btn btn-primary gred-btn'>Add a captain</button>
            </div>
            <div className="d-flex justify-content-center captain-modal">
              <div className='a-challenge-partner'>
                <h2 className='mb-60'>Edit a captain</h2>
                <Form>
                  <Form.Group className="mb-3" controlId="">
                    <FormLabel>Select a captain</FormLabel>
                    <Select
                      options={campCaptainsOptions}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: '6px',
                        colors: {
                          ...theme.colors,
                          primary: '#80e4e1',
                        },
                      })}
                      onChange={handleCampCaptainSelect}
                    />
                  </Form.Group>
                </Form>
                {selectedCampCaptain &&
                  <Form className='mt-50 mb-40' onSubmit={onSubmit}>
                    <Form.Group controlId="formFile" className="mb-3 upload-image">
                      <div className='customize-user-img  partner-editimg'>
                        <Image src={profilePic} alt="" />
                        <span className='customize-banner-upload' onClick={() => profileImage.current.click()}><Image src={customizeBannerUpload} alt="" /></span>
                        <input
                          className="d-none"
                          accept="image/png, image/jpeg, image/jpg, .heic, .HEIC"
                          id='profile_picture'
                          name='profile_picture'
                          type="file"
                          ref={profileImage}
                          onChange={(e) => handleProfileImageSelection(e)}
                        />
                      </div>
                    </Form.Group>
                    <Form.Row>
                      <Form.Group className="mb-3" controlId="">
                        <FormLabel>Captain's First Name</FormLabel>
                        <FormInput
                          name="captainFirstName"
                          className="form-input"
                          data-testid="first_name"
                          value={captainDetails?.captainFirstName}
                          placeholder='First Name'
                          ref={register({
                            required:
                              addCampCaptainErrors.first_name.required,
                          })}
                          onChange={handleChange}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="first_name"
                          className="small text-danger"
                          as="label"
                        />
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="">
                        <FormLabel>Captain's Last Name</FormLabel>
                        <FormInput
                          name="captainLastName"
                          className="form-input"
                          placeholder='Last Name'
                          value={captainDetails?.captainLastName}
                          data-testid="last_name"
                          ref={register({
                            required:
                              addCampCaptainErrors.last_name.required,
                          })}
                          onChange={handleChange}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="last_name"
                          className="small text-danger"
                          as="label"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Group className="mb-3" controlId="">
                      <FormLabel>Email</FormLabel>
                      <FormInput
                        name="captainEmail"
                        className="form-input"
                        data-testid="captainEmail"
                        value={captainDetails?.captainEmail}
                        ref={register({
                          required:
                            addCampCaptainErrors.email.required,
                        })}
                        onChange={handleChange}
                        // disabled={true}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="captainEmail"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                    <Form.Group className="flex-btn">
                      <LoadButton
                        className="common-round-btn submit-btn mt-5 mr-5 w-100 btn-danger"
                        text="Delete"
                        isLoading={isDeleteLoading}
                        onClick={handleDeleteCampCaptain}
                        isDisabled={selectedCampCaptain?.group_count !== 0}
                        type='button'
                        testid='button'
                      />
                      <LoadButton
                        className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                        text="Save Changes"
                        // isDisabled={!profilePic}
                        isLoading={isLoading}
                        testid="submit"
                      />
                    </Form.Group>
                  </Form>
                }
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}
export default CampEditCaptain;